import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Flex, Modal, type ModalProps, Typography } from 'antd';

import iceImage from 'assets/images/ice.webp';
import PlusIcon from 'assets/images/icons/plus.svg?react';
import { useCommonSlice } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';

interface IFrozenPopupProps extends ModalProps {}

export const FrozenPopup: FC<IFrozenPopupProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { isOpenFrozenPopup, setIsOpenFrozenPopup } = useCommonSlice();

	const handleAddClick = () => {
		setIsOpenFrozenPopup(false);
		navigate(`/${EMainRoutes.CHANNELS}/${EMainRoutes.CREATE}`);
	};

	return (
		<Modal
			open={isOpenFrozenPopup}
			onCancel={() => setIsOpenFrozenPopup(false)}
			destroyOnHidden
			footer={
				<Flex vertical gap={8}>
					<Button onClick={handleAddClick} size="large" type="primary" block icon={<PlusIcon />} iconPosition="end">
						{t('Добавить')}
					</Button>
					<Button onClick={() => setIsOpenFrozenPopup(false)} size="large" type="default" block>
						{t('Закрыть')}
					</Button>
				</Flex>
			}
			styles={{ body: { textAlign: 'center' } }}
			{...props}>
			<img src={iceImage} alt="" width={59} height={58} />
			<Typography.Title level={3} type="secondary">
				{t('Функции заморожены')}
			</Typography.Title>
			<Typography.Paragraph type="secondary">
				{t('Весь наш функционал оживает, как только вы добавите хотя бы один канал')}
			</Typography.Paragraph>
		</Modal>
	);
};
